import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { verifyEmail } from 'redux/actions/users.actions';
import { bindActionCreators, Dispatch } from 'redux';
import { CircularProgress, Typography } from '@mui/material';
import useTypedSelector from 'hooks/useTypedSelector';
import { IVerifyEmailRequest } from 'types/users.types';
import {
  TitleVerify,
  StyledPaper,
  LoadingContainer,
  PageWrapper,
  SuccessAlert,
  ErrorAlert,
} from 'styles/view';

interface IVerifyEmailContainerProps {
  verifyEmailAction: (formData: IVerifyEmailRequest) => void;
}

const VerifyEmailContainer: React.FC<IVerifyEmailContainerProps> = (props) => {
  const { verifyEmailAction } = props;
  const location = useLocation();
  const history = useHistory();

  // Obtenemos estados de la verificación desde el store
  const { loading, error, success } = useTypedSelector((state) => state.users);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const hash = queryParams.get('hash');

    if (id && hash) {
      verifyEmailAction({ id, hash });
    }
  }, [location, verifyEmailAction]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (success) {
      timer = setTimeout(() => {
        history.push('/public/procedures/login');
      }, 3000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [success, history]);

  return (
    <PageWrapper>
      <StyledPaper elevation={3}>
        <TitleVerify variant="h5">Verificación de Cuenta</TitleVerify>

        {loading && (
          <LoadingContainer>
            <CircularProgress size={40} sx={{ mb: 2 }} />
            <Typography>Procesando tu verificación...</Typography>
          </LoadingContainer>
        )}

        {success && (
          <SuccessAlert severity="success" variant="filled">
            ¡Correo verificado con éxito! Redirigiendo al inicio de sesión...
          </SuccessAlert>
        )}

        {error && (
          <ErrorAlert severity="error" variant="outlined">
            {typeof error === 'string' ? error : 'El enlace ha expirado o es inválido.'}
          </ErrorAlert>
        )}

        {!loading && !success && !error && (
          <Typography color="textSecondary">Esperando datos de verificación...</Typography>
        )}
      </StyledPaper>
    </PageWrapper>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  verifyEmailAction: bindActionCreators(verifyEmail, dispatch),
});

export default connect(null, mapDispatchToProps)(VerifyEmailContainer);
